const theTeam = {
  title: "Das Team",
  isabelle: {
    position: "Gründerin und Englischlehrerin",
    paragraphs: [
      "Als Lehrerin habe ich den Unterricht manchmal frustriert verlassen, weil es mir nicht gelungen war, die Aufmerksamkeit meiner Schülerinnen und Schüler zu gewinnen – ich hatte sie einfach „verloren“. Daraufhin begann ich intensiv nach Methoden, Themen und Aktivitäten zu suchen, die ihr Interesse wecken könnten. Dabei wurde mir immer klarer, dass ein entscheidender Teil der Lösung in einer differenzierten Unterrichtsgestaltung liegt.",
      "Aus dieser Überzeugung heraus entstand iizenglish – eine Plattform, die Lernende beim nachhaltigen Lernen unterstützt und regelmäßiges Wiederholen effektiv fördert.",
    ],
  },
  herve: {
    position: "Mitbegründer und Projektleiter",
    paragraphs: [
      "Er verfügt über langjährige internationale Erfahrung in der Umsetzung komplexer Projekte.",
      "Seine technische Expertise und sein ganzheitlicher Ansatz haben die Umsetzung der Plattform und ihrer Funktionen ermöglicht.",
    ],
  },
  kayla: {
    position: "Englischlehrerin",
    paragraphs: [
      "Es ist ihr ein besonderes Anliegen, Lösungen und Werkzeuge zu entwickeln, die das Potenzial jedes einzelnen Lernenden fördern.",
      "Als englische Muttersprachlerin ist sie unsere sprachliche Referenz.",
    ],
  },
  developers: {
    position: "Das Entwicklerteam",
    paragraphs: [
      "Unser Entwicklerteam arbeitet kontinuierlich daran, iizenglish intuitiv, zuverlässig und benutzerfreundlich zu gestalten.",
    ],
  },
  bodz: {
    position: "Künstler und visueller ‚Übersetzer‘",
    paragraphs: [
      "Mit großer Kreativität hat er die Herausforderung angenommen und die 1.275 Illustrationen entwickelt, die die Übungen visuell unterstützen und bereichern.",
      "{'@'}lunetlautre.fr",
    ],
  },
  bottomSection: {
    title: "Unser besonderer Dank gilt:",
    leftSection: {
      title: "Den Pionieren",
      content:
        "Den Lehrkräften, die von Anfang an an uns geglaubt und unsere Beta-Version getestet haben.",
    },
    rightSection: {
      title: "Unseren Unterstützerinnen und Unterstützern",
      content:
        "Den Eltern sowie Schülerinnen und Schülern, die ihre Erfahrungen mit den Hausaufgaben zu Hause mit uns geteilt und so zur Weiterentwicklung von iizenglish beigetragen haben.",
    },
  },
};

export default theTeam;
